import { useEffect, useState } from "react"
import styles from "./nfse.module.css"
import dayjs from "dayjs"
import r2slogo from '../../../../img/r2s-logo.png'
import oblogo from '../../../../img/ob-logo.png'
import { Button, Form, Spinner } from "react-bootstrap"
import { defineValueInInput, getValueFromInput } from "../../../../components/funcForInput"
import $ from 'jquery'
import 'jquery-mask-plugin'
import { ApiEndpoints, reqPostNew } from "../../../../config/apiClient"
import { createColumnHelper } from "@tanstack/react-table"
import DateTableSelectedNfs from "../../componentes/NfsLista"
import { toast } from "react-toastify"
import { getCookie } from "../../../../config/cookies"
import NotasEmpresaInfo from "./componentes/NotasEmpresaInfo"
import { useDispatch, useSelector } from "react-redux"
import { alterarStatusPrimeiroLoading, atualizar, selecionarNotas } from "./notasServicoSlice"
import NfseModalModelos from "./componentes/ModalNfseModelos"
import FiltroCompetencia from "./componentes/FiltroCompetencias"
import ModalEmitirNotasSelecionadas from "./componentes/ModalEmitirNotasSelecionadas"
import ModalImportarXML from "./componentes/ModalImportarXML"
import ModalImportarPDF from "./componentes/ModalImportarPDF"

export default function NotasSelecaoPage({ empresa, handleSairEmpresa, handleOpenNota, handleOpenModelo, filtros }: iNotasSelecaoPage) {
    const [competencias, setCompetencias] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [selection, setSelection] = useState<boolean>(false)
    const [showModalImportarXML, setShowModalImportarXML] = useState<boolean>(false)
    const [showModalImportarPDF, setShowModalImportarPDF] = useState<boolean>(false)
    const [showModalModelos, setShowModalModelos] = useState<boolean>(false)
    const [showModalEmitirVarias, setShowModalEmitirVarias] = useState<boolean>(false)
    const [notasSelecionadas, setNotasSelecionadas] = useState<any[]>([])
    const [dadosNotas, setDadosNotas] = useState<any[]>([])
    const notasServico: any[] = useSelector((state: any) => state.uiNotasServico.notas)
    const notasServicoCompetencias: any[] = useSelector((state: any) => state.uiNotasServico.competencias)
    const notasServicoAtualizar: string = useSelector((state: any) => state.uiNotasServico.atualizar)
    const notasServicoPrimeiroLoading: string = useSelector((state: any) => state.uiNotasServico.primeiro_loading)
    const dispatch = useDispatch()
    useEffect(() => {
        $('.dinheiro').mask('###.###.###.###.###.###.##0,00', { reverse: true, placeholder: "0,00" });
        $('.competencia').mask('00/0000', { reverse: false })
        document.title = `NF ${empresa.nome} | OB PORTUS`
        loadingCompetencias()
        // eslint-disable-next-line
    }, [])

    function handleChangeCompetencia(competencias: any[]) {
        if (competencias.length === 0) {
            setCompetencias([])
            loadingNotasCompetencias([])
            return
        }
        let competenciasAux: any[] = []
        for (let competencia of competencias) {
            if (competencia.value === "") {
                competenciasAux.push(competencia)
                break
            }
            let competenciaAux = competencia.value
            if (competenciaAux.length === 7) {
                const arrayComp = competenciaAux.split("/")
                const dados = {
                    "mes": Number(arrayComp[0]),
                    "ano": Number(arrayComp[1])
                }
                if (dados.mes < 0 || dados.mes >= 13) {
                    continue
                }
                if (dados.ano <= 2023 || dados.ano >= Number(dayjs().add(1, 'year').add(1, 'year').format("YYYY"))) {
                    continue
                }
                competenciasAux.push(competencia)
            }
        }

        setCompetencias(competenciasAux)
        const apiDados = competenciasAux.reduce((prev, current, idx, arr) => {
            prev.push(current.value)
            return prev
        }, [])
        loadingNotasCompetencias(apiDados)
    }
    async function loadingCompetencias() {
        setLoading(true)

        const mesAtual = dayjs().format("MM/YYYY")
        let competenciasAux: any[] = [{
            label: mesAtual,
            value: mesAtual,
        }]
        if (notasServicoAtualizar) {
            if (!notasServicoPrimeiroLoading && notasServicoCompetencias.length > 0) {
                competenciasAux = notasServicoCompetencias.reduce((prev, current, idx, array) => {
                    prev.push({
                        value: current,
                        label: current,
                    })
                    return prev
                }, [])
            }
            setCompetencias(competenciasAux)
            const apiDados = competenciasAux.reduce((prev, current, idx, arr) => {
                prev.push(current.value)
                return prev
            }, [])
            await loadingNotasCompetencias(apiDados)
        }

        if (!notasServicoAtualizar) {
            if (!notasServicoPrimeiroLoading && notasServicoCompetencias.length > 0) {
                competenciasAux = notasServicoCompetencias.reduce((prev, current, idx, array) => {
                    prev.push({
                        value: current,
                        label: current,
                    })
                    return prev
                }, [])
            }
            if (notasServico.length === 0) {
                setCompetencias(competenciasAux)
                const apiDados = competenciasAux.reduce((prev, current, idx, arr) => {
                    prev.push(current.value)
                    return prev
                }, [])
                await loadingNotasCompetencias(apiDados)
            } else {
                setCompetencias(competenciasAux)
                let notas_aux: any[] = notasServico
                setDadosNotas(notas_aux)
            }
        }

        setLoading(false)
    }
    async function recarregarNotasCompetencias() {
        let competenciasAux: any[] = notasServicoCompetencias.reduce((prev, current, idx, array) => {
            prev.push({
                value: current,
                label: current,
            })
            return prev
        }, [])
        const apiDados = competenciasAux.reduce((prev, current, idx, arr) => {
            prev.push(current.value)
            return prev
        }, [])
        await loadingNotasCompetencias(apiDados)
    }
    async function loadingNotasCompetencias(competencias: string[]) {
        setLoading(true)

        const dadosNotas = {
            id_empresa: empresa.id_empresa,
            meses: competencias
        }
        const api = await reqPostNew(ApiEndpoints.nfseListarCompetencias, dadosNotas)
        if (api.status === 200) {
            let notas_aux: any[] = api.data
            for (let idx in notas_aux) {
                notas_aux[idx].valor_servicos = `R$ ${formatarDinheiro(notas_aux[idx].valor_servicos)}`
                notas_aux[idx].valor_liquido = `R$ ${formatarDinheiro(notas_aux[idx].valor_liquido)}`
            }
            setDadosNotas(notas_aux)
            dispatch(atualizar({ notas: notas_aux, competencias: competencias }))
            dispatch(alterarStatusPrimeiroLoading({ primeiro_loading: false }))
        }

        setLoading(false)
    }

    function handleRowClick(event: any) {
        let idx = Number(event.target.parentElement.getAttribute('about'))
        if (event.target.localName === "span") {
            idx = Number(event.target.parentElement.parentElement.parentElement.parentElement.getAttribute('about'))
        }
        const nota = dadosNotas[idx]
        if (event.button === 1 && event.target.localName !== "span") {
            window.open(`/nfse?id_empresa=${empresa.id_empresa}&id_nota=${nota.id}`)
        } else if (event.target.localName !== "span") {
            handleOpenNota(nota)
        }

        if (event.target.localName === "span") {

            if (nota.emitido === 0) {
                toast.warning("Nota ainda não foi emitida!", {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }
        }
    }
    async function handleDownloadRelatorioExcel() {
        if (!window.confirm("Tem certeza que deseja baixar o relatório do filtro atual?")) {
            return
        }

        setLoading(true)

        let competenciaAux = ""
        if (competencias.length > 0) {
            competenciaAux = competencias[0].value
        }
        if (competenciaAux !== "") {
            competenciaAux = `${competenciaAux.split("/")[1]}-${competenciaAux.split("/")[0]}`
        }
        const dadosDownload = {
            id_empresa: empresa.id_empresa,
            competencia: competenciaAux,
        }

        return new Promise(function (resolve, reject) {
            var token = getCookie('token')
            var id_usuario = getCookie('id_user')
            let request = new XMLHttpRequest();

            request.responseType = "blob";
            request.open("POST", ApiEndpoints.nfseRelatorioExcel.endpoint, true)
            request.setRequestHeader("Content-Type", "application/json")
            request.setRequestHeader("Authorization", `Bearer ${token}`)
            request.setRequestHeader("id_usuario", id_usuario)
            request.send(JSON.stringify(dadosDownload))

            request.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    const imageURL = window.URL.createObjectURL(this.response)
                    const anchor = document.createElement("a")
                    anchor.href = imageURL
                    anchor.download = `${empresa.nome} NFs Relatorio ${dadosDownload.competencia === "" ? "" : dadosDownload.competencia}.xlsx`
                    document.body.appendChild(anchor)
                    anchor.click()
                    setLoading(false)
                    resolve('')
                } else if (this.status === 401 || this.status === 400) {
                    toast.error('Erro Download!', {
                        containerId: 1,
                        position: 'top-center',
                        theme: 'dark'
                    })
                    setLoading(false)
                    resolve('')
                }
            }
        })
    }

    function handleModeloOpen(modelo: any) {
        setShowModalModelos(false)
        handleOpenModelo(modelo)
    }

    async function emitirVariasNotas() {
        const ids_notas = getNfsSelected()
        if (ids_notas.length === 0) {
            toast.warning("Selecione alguma NFS-e!", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            return
        }

        let notas = []
        let nota_invalida = false
        for (let id_nota of ids_notas) {
            for (let nota of dadosNotas) {
                if (nota.id === id_nota) {
                    notas.push({
                        nota: nota,
                        emissao: {}
                    })
                    if (nota.status !== "Não Emitido" && nota.status !== "Erro ao Emitir") {
                        nota_invalida = true
                    }
                }
            }
        }
        if (nota_invalida) {
            toast.warning("Selecione apenas notas que ainda não foram emitidas!", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            return
        }

        setShowModalEmitirVarias(true)
        setNotasSelecionadas(notas)
        dispatch(selecionarNotas({ notas_selecionadas: notas }))
    }
    function getNfsSelected(): any[] {
        let rows = getValueFromInput('rowsSelected')
        let notasAux: any[] = JSON.parse(rows)
        notasAux = notasAux.map((reg: any, idx: any) => (dadosNotas[Number(reg[0])].id))
        return notasAux
    }
    async function handleCloseModalEmitirNotas(opcoes: any) {
        setNotasSelecionadas([])
        setShowModalEmitirVarias(false)
        dispatch(selecionarNotas({ notas_selecionadas: [] }))
        if (opcoes.atualizar) {
            recarregarNotasCompetencias()
        }
    }

    return (
        <div>
            <NfseModalModelos empresa={empresa} handleClose={() => { setShowModalModelos(false) }} show={showModalModelos} handleModelo={(modelo: any) => { handleModeloOpen(modelo) }} modelos={filtros.modelos} />
            <ModalEmitirNotasSelecionadas show={showModalEmitirVarias} notas={notasSelecionadas} handleClose={(opcoes: any) => { handleCloseModalEmitirNotas(opcoes) }} />
            <ModalImportarXML show={showModalImportarXML} handleClose={() => { setShowModalImportarXML(false) }} handleUpdate={() => {recarregarNotasCompetencias()}} />
            <ModalImportarPDF show={showModalImportarPDF} handleClose={() => { setShowModalImportarPDF(false) }} handleUpdate={() => {recarregarNotasCompetencias()}} />
            <Form.Control name='dinheiro_aux' type="text" id='dinheiro_aux' className='dinheiro' placeholder="0,00" style={{ display: "none" }} />
            <div className="div-row">
                <div className={styles.painelEmpresaLogo} onClick={() => { handleSairEmpresa() }} style={{ width: "430px" }}>
                    {empresa.id_empresa === 1 && <img src={r2slogo} about="LOGO" alt="LOGO"></img>}
                    {empresa.id_empresa > 1 && <img src={oblogo} about="LOGO" alt="LOGO"></img>}
                    <h2>{empresa.nome}</h2>
                </div>
                <NotasEmpresaInfo empresa={empresa} notas={dadosNotas} />
            </div>
            <div className="div-row" style={{ marginTop: "10px", marginBottom: "10px" }}>
                <FiltroCompetencia handleChangeCompetencia={handleChangeCompetencia} competencias={competencias} />
                <Button variant='secundary' style={{ marginRight: "10px" }} onClick={() => setSelection(!selection)}>Seleção: {selection ? "Ativado" : "Desativado"}</Button>
                <Button onClick={() => { handleOpenNota(0) }} style={{ marginRight: "10px" }}>Nova</Button>
                <Button onClick={() => { setShowModalModelos(true) }} style={{ marginRight: "10px" }}>Modelos</Button>
                <Button onClick={() => { handleDownloadRelatorioExcel() }} style={{ marginRight: "10px" }} variant="success">Relatório Excel</Button>
                <Button onClick={() => { emitirVariasNotas() }} style={{ marginRight: "10px" }} variant="warning" >Emitir Selecionadas</Button>
                <Button onClick={() => { setShowModalImportarXML(true) }} style={{ marginRight: "10px" }} variant="success" >Importar XML</Button>
                <Button onClick={() => { setShowModalImportarPDF(true) }} style={{ marginRight: "10px" }} variant="success" >Importar PDF</Button>
            </div>

            {loading && <Spinner></Spinner>}
            {!loading && <DateTableSelectedNfs dados={dadosNotas} tableSize={'auto'} defaultColumns={defaultColumns} defaultOrder={defaultOrder} select={selection} handleRowClick={handleRowClick} />}
        </div>
    )
}
interface iNotasSelecaoPage {
    empresa: any
    handleSairEmpresa: any
    handleOpenNota: any
    handleOpenModelo: any
    filtros: any
}


const columnHelper = createColumnHelper<any>()

const defaultColumns = [
    columnHelper.accessor(row => '', {
        id: 'select',
        header: ({ table }) => (
            <input type="checkbox" checked={table.getIsAllRowsSelected()} onChange={table.getToggleAllRowsSelectedHandler()} />
        ),
        cell: ({ row }) => (
            <input type="checkbox" checked={row.getIsSelected()} disabled={!row.getCanSelect()} onChange={row.getToggleSelectedHandler()} />
        ),
        size: 15,
        enableSorting: false,
    }),
    columnHelper.accessor(row => `${dayjs(row.dps_data_competencia).format("MM/YYYY")}`, {
        header: 'Compet.',
        size: 55,
    }),
    columnHelper.accessor(row => row.status, {
        id: 'status',
        header: 'Status',
        size: 95,
    }),
    columnHelper.accessor(row => ``, {
        id: 'view',
        header: '',
        cell: ({ row }) => (
            <div>
                {
                    ((row.original.status === "Emitido" || row.original.status === "Emitido (Cancelado)") && row.original.danf_baixada === 1) &&
                    <a href={`${ApiEndpoints.apiNew}/nfse/danfse/view/${row.original.id_chave}`} target="_blank" rel="noreferrer">
                        <span className="material-symbols-outlined" style={{ fontSize: '20px', zIndex: '10' }}>
                            visibility
                        </span>
                    </a>
                }
                {
                    ((row.original.status === "Emitido" || row.original.status === "Emitido (Cancelado)") && row.original.danf_baixada === 0) &&
                    <a href={`${ApiEndpoints.apiNew}/nfse/danfse/view/${row.original.id_chave}`} target="_blank" rel="noreferrer">
                        <span className="material-symbols-outlined" style={{ fontSize: '20px', zIndex: '10', color: "red" }}>
                            visibility_off
                        </span>
                    </a>
                }
            </div>
        ),
        size: 5,
    }),
    columnHelper.accessor(row => row.valor_servicos, {
        header: 'R$ Vl.',
        size: 75,
    }),
    columnHelper.accessor(row => `${row.nNFSe === null ? '' : `NFS-e ${row.nNFSe}`} ${row.id_cliente.nome} ${row.situacao_importacao !== 1 ? '' : ` #XML-IMPORT`}`, {
        header: 'Descrição',
        size: 400,
    }),

    columnHelper.accessor(row => dayjs(row.data_criacao).format("DD/MM/YYYY HH:mm"), {
        header: 'Criado em',
        size: 100,
    }),
    columnHelper.accessor(row => row.servico_cidade_descricao, {
        header: 'Cidade',
        size: 75,
    }),
    columnHelper.accessor(row => row.trib_iss_ret === 2 ? "Retido" : "Tributado", {
        header: 'Situação',
        size: 55,
    }),
    columnHelper.accessor(row => `${row.servico_cod} - ${String(row.servico_descricao).substring(0, 32)}...`, {
        header: 'Serv.',
        size: 200,
    }),
    // columnHelper.accessor(row => row.id_cliente.nome, {
    //     header: 'Tomador',
    //     size: 220
    // }),
]

const defaultOrder: any[] = []

function formatarDinheiro(valor: string): string {
    defineValueInInput("dinheiro_aux", valor)
    return $("#dinheiro_aux").masked(valor)
}
